'use strict'

import template from './ums-document-card.template.pug'

export class DocumentCardController {
  constructor($filter) {
    'ngInject'
    Object.assign(this, { $filter })
  }

  downloadPdf() {
    const type = this.$filter('documentTypeFilter')(this.document.type)
    const fileName = this.document.documentDate + '_' + type + '_' + this.document.no
    this.customer.getDocumentPdf(this.document.archiveRef, fileName)
  }

  downloadZip() {
    const fileName = this.document.documentDate + '_' + this.document.zipRef
    this.customer.getDocumentZip(this.document.zipRef, fileName)
  }
}

export const umsDocumentCard = {
  template: template(),
  bindings: {
    document: '<',
    customer: '<',
  },
  controller: DocumentCardController,
}



// WEBPACK FOOTER //
// ./app/documents/components/document-card/ums-document-card.component.js